import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './index.css'
import { AnalyticsService } from "@/services/analytics.js";
import { APP_VERSION, SEGMENT_KEY } from "@/config-global.jsx";

if (SEGMENT_KEY) {
    AnalyticsService.init()
}

window.tellMeVersion = () => {
    console.log(APP_VERSION)
}


ReactDOM.createRoot(document.getElementById('root')).render(<App />)
